import React from "react";
import { ProducerFieldSelectTemplate } from "themes/common/components/producer";

function ProducerFieldSelect(props) {
    return <ProducerFieldSelectTemplate {...props} />;
}

export default ProducerFieldSelect;
